import { apiService } from './api';

export interface CustomerAttributeFieldDTO {
  attributeDefinitionId: number;
  code: string;
  name: string;
  dataType: string;
  options?: string[] | null;
  unit?: string | null;
  isRequired: boolean;
  sortOrder: number;
  value?: string | null;
}

export interface CustomerAttributesDTO {
  customerId: number;
  appCode?: string | null;
  setName?: string | null;
  attributes: CustomerAttributeFieldDTO[];
}

const API = '/customers';

export const customerAttributeService = {
  getForm: (appCode: string) =>
    apiService.get<CustomerAttributesDTO>(`${API}/attributes/form`, { appCode }),
  getForCustomer: (customerId: number, appCode: string) =>
    apiService.get<CustomerAttributesDTO>(`${API}/${customerId}/attributes`, { appCode }),
  save: (customerId: number, appCode: string, values: { attributeDefinitionId: number; value: string | null }[]) =>
    apiService.put<CustomerAttributesDTO>(`${API}/${customerId}/attributes?appCode=${encodeURIComponent(appCode)}`, { values }),
};
